import { render } from "./Masquerade.vue?vue&type=template&id=ce1ae004"
import script from "./Masquerade.vue?vue&type=script&lang=js"
export * from "./Masquerade.vue?vue&type=script&lang=js"

import "./Masquerade.vue?vue&type=style&index=0&id=ce1ae004&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__